import styled from '@emotion/styled';
import React, { FC } from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import { Box } from '~Styles';

const Dimmer = styled(Box)`
  height: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.65);
  z-index: 3;
`;

interface Props {
  showDimmer?: boolean;
  color?: string;
  /** Size sm fits best in our ~/Styles/Button, xs in size="small" buttons (handy) */
  size?: 'xs' | 'sm' | 'md';
}

/** Classic spinner */
const Loader: FC<Props> = ({ showDimmer, color, size = 'md' }) => {
  const sizeValue = size === 'xs' ? 12 : size === 'sm' ? 16 : 38;

  if (showDimmer) {
    return (
      <Dimmer display="flex" alignItems="center" justifyContent="center" fluid>
        <CircleSpinner loading size={sizeValue} color={color ? color : '#ddd'} />
      </Dimmer>
    );
  }

  return <CircleSpinner loading size={sizeValue} color={color ? color : '#ddd'} />;
};

export default Loader;
